<div class="dialog__container">
  <div class="dialog__header">
    <span>{{ title }}</span>
  </div>
  <div class="dialog__content">
    <div class="dialog__label" *ngIf="message">
      <span>{{ message }}</span>
    </div>
    <ng-container [formGroup]="confirmForm">
      <div class="dialog__input-container" *ngIf="dropdownOptions.length">
        <app-dropdown
          [options]="dropdownOptions"
          [placeholder]="dropdownPlaceholder"
          formControlName="dropdown">
        </app-dropdown>
      </div>
      <div class="dialog__input-container" *ngIf="showInput">
        <app-form-input
          [placeholder]="inputPlaceholder"
          [type]="inputType"
          formControlName="input">
        </app-form-input>
      </div>
    </ng-container>
  </div>
  <div class="dialog__footer">
    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Cancel"
        (clicked)="onCancel()">
        {{ 'webPos.Cancel' | translate }}
      </app-action-button>
    </div>
    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Confirm"
        [disabled]="confirmForm.invalid && showInput"
        (clicked)="onConfirm()">
      {{ confirmButtonText }}
    </app-action-button>
    </div>
  </div>
</div>
